/**
 * @fileoverview Navigation locale de l'espace compte agent.
 *
 * Les écrans profil, sécurité et MFA sont séparés pour éviter une page
 * d'administration trop dense. Ce composant garde le même patron de navigation
 * sur chaque sous-page.
 */

import { cn } from '@gnpc/ui';
import { KeyRound, ShieldCheck, UserRound, type LucideIcon } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface AccountNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
}

const ACCOUNT_NAV_ITEMS: readonly AccountNavItem[] = [
  { label: 'Profil', to: '/account/profile', icon: UserRound },
  { label: 'Sécurité', to: '/account/security', icon: ShieldCheck },
  { label: 'MFA', to: '/account/mfa', icon: KeyRound },
];

export function AccountNav(): JSX.Element {
  return (
    <nav aria-label="Navigation du compte agent" className="flex flex-wrap gap-2">
      {ACCOUNT_NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            cn(
              'inline-flex h-9 items-center gap-2 rounded-md border px-3 text-sm font-medium transition-colors',
              isActive
                ? 'border-quipux-navy-950 bg-quipux-navy-950 text-white'
                : 'border-border bg-background text-quipux-navy-950 hover:bg-quipux-navy-50',
            )
          }
        >
          <item.icon className="size-4" />
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
